import type { SVGProps } from 'react'
const SvgSyMessageAlt = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<rect width={16} height={12} x={4} y={6} fillOpacity={0.24} rx={2} />
		<path d="M4 16V9.243a.15.15 0 0 1 .217-.134l6.441 3.22a3 3 0 0 0 2.684 0l6.44-3.22a.15.15 0 0 1 .218.134V16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2" />
	</svg>
)
export default SvgSyMessageAlt
